// extracted by mini-css-extract-plugin
export default {"container":"SignUpPage_container__hX3bl","title":"SignUpPage_title__d1pdf","description":"SignUpPage_description__J14ZD"};